import { useState, useEffect } from "react";
import "./transformacije.css";

import img1 from "../../components/images/transformacije/1.jpg";
import img2 from "../../components/images/transformacije/2.jpg";
import img3 from "../../components/images/transformacije/3.jpg";
import img4 from "../../components/images/transformacije/4.jpg";
import img5 from "../../components/images/transformacije/5.jpg";
import img6 from "../../components/images/transformacije/6.jpg";
import img7 from "../../components/images/transformacije/7.jpg";
import img8 from "../../components/images/transformacije/8.jpg";
import img9 from "../../components/images/transformacije/9.jpg";
import img10 from "../../components/images/transformacije/10.jpg";
import img11 from "../../components/images/transformacije/11.jpg";
import img12 from "../../components/images/transformacije/12.jpg";
import img13 from "../../components/images/transformacije/13.jpg";
import img14 from "../../components/images/transformacije/14.jpg";
import img15 from "../../components/images/transformacije/15.jpg";
import img16 from "../../components/images/transformacije/16.jpg";
import img17 from "../../components/images/transformacije/17.jpg";
import img18 from "../../components/images/transformacije/18.jpg";
import img19 from "../../components/images/transformacije/19.jpg";
import img20 from "../../components/images/transformacije/20.jpg";
import img21 from "../../components/images/transformacije/21.jpg";
import img22 from "../../components/images/transformacije/22.jpg";
import img23 from "../../components/images/transformacije/23.jpg";
import { Title } from "../../global";

const DEMO = [
  { id: 1, img: img1 },
  { id: 2, img: img2 },
  { id: 3, img: img3 },
  { id: 4, img: img4 },
  { id: 5, img: img5 },
  { id: 6, img: img6 },
  { id: 7, img: img7 },
  { id: 8, img: img8 },
  { id: 9, img: img9 },
  { id: 10, img: img10 },
  { id: 11, img: img11 },
  { id: 12, img: img12 },
  { id: 13, img: img13 },
  { id: 14, img: img14 },
  { id: 15, img: img15 },
  { id: 16, img: img16 },
  { id: 17, img: img17 },
  { id: 18, img: img18 },
  { id: 19, img: img19 },
  { id: 20, img: img20 },
  { id: 21, img: img21 },
  { id: 22, img: img22 },
  { id: 23, img: img23 },
];

export default function Transformacije() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleOpen = (index) => setSelectedIndex(index);
  const handleClose = () => setSelectedIndex(null);

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev === 0 ? DEMO.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prev) => (prev === DEMO.length - 1 ? 0 : prev + 1));
  };

  // Tastatura: ← → Esc
  useEffect(() => {
    const onKeyDown = (e) => {
      if (selectedIndex === null) return;
      if (e.key === "ArrowLeft") handlePrev();
      else if (e.key === "ArrowRight") handleNext();
      else if (e.key === "Escape") handleClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [selectedIndex]);

  return (
    <div className="tf-wrap">
      <Title style={{ marginTop: "30px" }}>Transformacije</Title>

      <section className="tf-grid">
        {DEMO.map(({ id, img }, index) => (
          <article
            key={id}
            className="tf-card"
            onClick={() => handleOpen(index)}
            tabIndex={0}
            role="button"
            aria-label={`Otvori sliku ${id}`}
          >
            <div className="tf-card__media">
              <img src={img} alt={`Transformacija ${id}`} />
            </div>
          </article>
        ))}
      </section>

      {selectedIndex !== null && (
        <div className="tf-modal" onClick={handleClose}>
          <div className="tf-modal__backdrop" />
          <div
            className="tf-modal__content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <header className="tf-modal__header">
              <button
                className="tf-iconbtn tf-close"
                onClick={handleClose}
                aria-label="Zatvori"
              >
                &times;
              </button>
            </header>

            <button
              className="tf-nav tf-prev"
              aria-label="Prethodna slika"
              onClick={handlePrev}
            >
              &#10094;
            </button>

            <div className="tf-modal__media">
              <img
                src={DEMO[selectedIndex].img}
                alt={`Transformacija ${DEMO[selectedIndex].id}`}
              />
            </div>

            <button
              className="tf-nav tf-next"
              aria-label="Sledeća slika"
              onClick={handleNext}
            >
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
